<template>
  <li class="flex items-center pb-6 px-4" :class="{ 'cursor-pointer': hasTooltip }">
    <MTooltip :disabled="!hasTooltip">
      <template #toggle>
        <div class="flex items-center">
          <img
            v-if="content.icon?.url"
            class="shrink-0 w-8 h-8 mr-4 mt-6 object-contain"
            :src="content.icon.url"
            :alt="content.icon.alt ?? ''"
          />
          <PortableText class="typography text-16" :content="content.text" />
        </div>
      </template>
      <template #content>
        <PortableText class="typography no-top-spacing text-14" :content="content.tooltip" />
      </template>
    </MTooltip>
  </li>
</template>

<script lang="ts" setup>
import { toPlainText } from '@portabletext/vue'
import type { GQLCalloutSlice } from './generated/callout'

const props = defineProps<{ content: GQLCalloutSlice['items'][number] }>()

const hasTooltip = computed(() => {
  return Boolean(props.content.tooltip && toPlainText(props.content.tooltip))
})
</script>
